import { FC, memo } from 'react'
import { Button } from '@chakra-ui/react'

import SalaryCard from 'InstitutionalManagement/components/SalaryCard'
import { Salary } from 'InstitutionalManagement/types'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import { useCustomFormSalarySelectionDrawerManager } from '../../../../contexts/CustomFormSalarySelectionDrawerManager/Provider'

type Props = {
  salary: Salary
  onClose: () => void
}

const CustomFormSalaryCardToSelect: FC<Props> = ({ salary, onClose }) => {
  const { questionKey, selectedSalary, setSelectedSalary, filter } = useCustomFormSalarySelectionDrawerManager()

  const { formMethods } = useCustomFormViewer()

  function selectSalary(selectedSalary: Salary) {
    formMethods?.setValue(questionKey, [selectedSalary.id, selectedSalary.slug, selectedSalary.name])
    setSelectedSalary(selectedSalary)
  }

  function removeSalary() {
    formMethods?.setValue(questionKey, undefined)
    setSelectedSalary({})
  }

  return (
    <SalaryCard salary={salary} salaryFilter={filter}>
      {selectedSalary?.id === salary.id ? (
        <Button width="100%" variant="outline" colorScheme="red" onClick={() => removeSalary()}>
          Remover
        </Button>
      ) : (
        <Button
          width="100%"
          variant="outline"
          onClick={() => {
            selectSalary(salary)
            onClose()
          }}
        >
          Selecionar
        </Button>
      )}
    </SalaryCard>
  )
}

export default memo(CustomFormSalaryCardToSelect)
